import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy',
  templateUrl: './cubique-privacy.component.html',
  styleUrls: ['./cubique-privacy.component.scss']
})
export class CubiquePrivacyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
